module.exports = __webpack_public_path__ + "static/media/9.Curing-Pump-BE-Equivalent.28891a76.webp";